// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3156a1ed","435":"19c21ce7","453":"9aee97bb"}[chunkId] + ".chunk.js";
};